<div
    [style.border-bottom]="getStaticPartStyle()"
    [style.border-left]="getStaticPartStyle()"
    [style.border-right]="getStaticPartStyle()"
    [style.border-top]="getMovingPartStyle()"
    [style.font-size]="getSizePx()"
    [style.margin]="margin"
    class="spinner">
</div>
